// -----------------------------------------------------------------------------
// getAddressTextFromData (data = {}, opts = {})
//
// -----------------------------------------------------------------------------
// if opts.multi_line = true, returns object:
// {
//   street_1: <Line 1 of street address>
//   street_2: <Line 2 of street address -or- null>
//   area:     <Line containing remaining address info>
// }
//
// if opts.multi_line = false (default): returns a string value
// -----------------------------------------------------------------------------
const getAddressTextFromData = (data = {}, opts = {}) => {
  const multiLines = opts.multi_lines === true
  const includeCountry = opts.include_country === true

  const street1 = data.street_1 || ''
  const street2 = data.street_2
  const street = (street2) ? `${street1}, ${street2}` : street1
  const city = data.city || ''
  const state = data.state
  const region = (state) ? `${city}, ${state}` : city
  const zip = (data.zip && data.zip !== 'null') ? data.zip : null
  const postalCode = data.postal_code || ''
  const zipOrPostal = zip || postalCode
  const country = data.country || ''

  // Return as object with multi lines
  if (multiLines) {
    const multi = { street_1: street1 }
    if (street2) multi.street_2 = street2
    if (includeCountry) {
      multi.area = `${region} ${zipOrPostal} ${country}`
    } else {
      multi.area = `${region} ${zipOrPostal}`
    }
    return multi

  // Return as a single string
  } else {
    return (includeCountry)
      ? `${street}, ${region} ${zipOrPostal} ${country}`
      : `${street}, ${region} ${zipOrPostal}`
  }
}

module.exports = {
  getAddressTextFromData
}
